module.exports = "/assets/data/2554f7f84c0783f811b4c820eb43ff39-SG12.data.json";